import i18n from "../i18n";
const t = (k: string, fb?: string) => (i18n.t ? i18n.t(k, fb || k) : fb || k);
import { isEmpty, uniqueId } from "lodash";
import { COURSE_STATUS, QuestionTypeEnum } from "../constants";
import * as htmlDocx from "html-docx-js/dist/html-docx";
import { saveAs } from "file-saver";
import { parse } from "mathjs";
import { message, PaginationProps } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

export const renderStatusCourse = (status: any) => {
  switch (status) {
    case null:
      return (
        <>
          <div className="dot color-wait" />
          
          {t("Chờ quản trị khoá học duyệt", "Chờ quản trị khoá học duyệt")}
        
        </>
      );
    case 3:
      return (
        <>
          <div className="dot color-wait" />
          
          {t("Chờ quản trị khoá học duyệt", "Chờ quản trị khoá học duyệt")}
        
        </>
      );
    case 4:
      return (
        <>
          <div className="dot color-refuse" />
          
          {t("Quản trị khoá học trả lại", "Quản trị khoá học trả lại")}
        
        </>
      );
    case 5:
      return (
        <>
          <div className="dot color-wait" />
          
          {t("Chờ hội đồng thẩm định duyệt", "Chờ hội đồng thẩm định duyệt")}
        
        </>
      );
    case 6:
      return (
        <>
          <div className="dot color-refuse" />
          
          {t("Hội đồng thẩm định không duyệt", "Hội đồng thẩm định không duyệt")}
        
        </>
      );
    case 7:
      return (
        <>
          <div className="dot color-done" />
          
          {t("Chờ tổ chuyên môn duyệt", "Chờ tổ chuyên môn duyệt")}
        
        </>
      );
    // case 8:
    //   return (
    //     <>
    //       <div className="dot color-done" />
    //       Đã duyệt
    //     </>
    //   );
    // case 9:
    //   return (
    //     <>
    //       <div className="dot color-wait" />
    //       Chờ tổ chuyên phê duyệt
    //     </>
    //   );
    // case 10:
    //   return (
    //     <>
    //       <div className="dot color-done" />
    //       Chờ xuất bản
    //     </>
    //   );
    case 11:
      return (
        <>
          <div className="dot color-refuse" />
          
          {t("Tổ chuyên môn trả lại", "Tổ chuyên môn trả lại")}
        
        </>
      );
    case 12:
      return (
        <>
          <div className="dot color-wait" />
          
          {t("Chờ xuất bản", "Chờ xuất bản")}
        
        </>
      );
    case 13:
      return (
        <>
          <div className="dot color-done" />
          
          {t("Đã xuất bản", "Đã xuất bản")}
        
        </>
      );
    default:
      return "";
  }
};

export const renderQuestionNameByType = (type: number) => {
  switch (type) {
    case QuestionTypeEnum.CHOOSE_TEXT:
      return t("Câu hỏi nhiều lựa chọn văn bản", "Câu hỏi nhiều lựa chọn văn bản");
    case QuestionTypeEnum.CHOOSE_IMAGE:
      return t("Câu hỏi nhiều lựa chọn ảnh", "Câu hỏi nhiều lựa chọn ảnh");
    case QuestionTypeEnum.CHOOSE_VIDEO:
      return t("Câu hỏi nhiều lựa chọn video", "Câu hỏi nhiều lựa chọn video");
    case QuestionTypeEnum.TRUE_OR_FALSE:
      return t("Câu hỏi dạng đúng sai", "Câu hỏi dạng đúng sai");
    case QuestionTypeEnum.DROP_DOWN:
      return t("Câu hỏi dạng danh sách", "Câu hỏi dạng danh sách");
    case QuestionTypeEnum.CHOOSE_MULTI_TEXT:
      return t("Câu hỏi dạng nhiều câu trả lời văn bản", "Câu hỏi dạng nhiều câu trả lời văn bản");
    case QuestionTypeEnum.CHOOSE_MULTI_IMAGE:
      return t("Câu hỏi dạng nhiều câu trả lời ảnh", "Câu hỏi dạng nhiều câu trả lời ảnh");
    case QuestionTypeEnum.CHOOSE_MULTI_VIDEO:
      return t("Câu hỏi dạng nhiều câu trả lời video", "Câu hỏi dạng nhiều câu trả lời video");
    case QuestionTypeEnum.CONNECT:
      return t("Câu hỏi dạng kết nối", "Câu hỏi dạng kết nối");
    case QuestionTypeEnum.SHORT_TEXT:
      return t("Câu hỏi trả lời dạng văn bản ngắn", "Câu hỏi trả lời dạng văn bản ngắn");
    case QuestionTypeEnum.FILE_UPLOAD:
      return t("Câu hỏi trả lời bằng file đính kèm", "Câu hỏi trả lời bằng file đính kèm");
    case QuestionTypeEnum.VIDEO:
      return t("Câu hỏi trả lời bằng ghi hình", "Câu hỏi trả lời bằng ghi hình");
    case QuestionTypeEnum.MP3:
      return t("Câu hỏi trả lời bằng ghi âm", "Câu hỏi trả lời bằng ghi âm");
    case QuestionTypeEnum.CALCULATED:
      return t("Câu hỏi tính toán loại 1", "Câu hỏi tính toán loại 1");
    case QuestionTypeEnum.CALCULATED_SIMPLE:
      return t("Câu hỏi tính toán loại 2", "Câu hỏi tính toán loại 2");
    case QuestionTypeEnum.CALCULATED_MULTI:
      return t("Câu hỏi tính toán nhiều đáp án", "Câu hỏi tính toán nhiều đáp án");
    case QuestionTypeEnum.ESSAY:
      return t("Câu hỏi tự luận", "Câu hỏi tự luận");
    case QuestionTypeEnum.NUMERICAL:
      return t("Câu hỏi điển số", "Câu hỏi điển số");
    case QuestionTypeEnum.QUIZ_EDITOR:
      return t("Trình soạn thảo", "Trình soạn thảo");
    case QuestionTypeEnum.DRAG_DROP_INTO_TEXT:
      return t("Câu hỏi kéo thả vào văn bản", "Câu hỏi kéo thả vào văn bản");
    case QuestionTypeEnum.EMBEDDED_ANSWER:
      return t("Câu hỏi điển khuyết", "Câu hỏi điển khuyết");
    default:
      break;
  }
};

export const renderQuestionDescriptionByType = (type: number) => {
  switch (type) {
    case QuestionTypeEnum.CHOOSE_TEXT:
      return t("Là loại câu hỏi có nhiều lựa chọn, nhưng chỉ có 01 đáp án là đúng", "Là loại câu hỏi có nhiều lựa chọn, nhưng chỉ có 01 đáp án là đúng");
    case QuestionTypeEnum.CHOOSE_IMAGE:
      return t("Là loại câu hỏi có nhiều lựa chọn hình ảnh kèm mô tả, nhưng chỉ có 01 đáp án là đúng", "Là loại câu hỏi có nhiều lựa chọn hình ảnh kèm mô tả, nhưng chỉ có 01 đáp án là đúng");
    case QuestionTypeEnum.CHOOSE_VIDEO:
      return t("Là loại câu hỏi có nhiều lựa chọn video kèm mô tả, nhưng chỉ có 01 đáp án là đúng", "Là loại câu hỏi có nhiều lựa chọn video kèm mô tả, nhưng chỉ có 01 đáp án là đúng");
    case QuestionTypeEnum.TRUE_OR_FALSE:
      return t("Là loại câu hỏi có 02 lựa chọn và chỉ có 01 đáp án là đúng", "Là loại câu hỏi có 02 lựa chọn và chỉ có 01 đáp án là đúng");
    case QuestionTypeEnum.DROP_DOWN:
      return t("Là loại câu hỏi có nhiều lựa chọn trong danh sách, nhưng chỉ có 01 đáp án là đúng", "Là loại câu hỏi có nhiều lựa chọn trong danh sách, nhưng chỉ có 01 đáp án là đúng");
    case QuestionTypeEnum.CHOOSE_MULTI_TEXT:
      return t("Là loại câu hỏi có nhiều lựa chọn, và có nhiều đáp án là đúng", "Là loại câu hỏi có nhiều lựa chọn, và có nhiều đáp án là đúng");
    case QuestionTypeEnum.CHOOSE_MULTI_IMAGE:
      return t("Là loại câu hỏi có nhiều lựa chọn hình ảnh kèm mô tả, và có nhiều đáp án là đúng", "Là loại câu hỏi có nhiều lựa chọn hình ảnh kèm mô tả, và có nhiều đáp án là đúng");
    case QuestionTypeEnum.CHOOSE_MULTI_VIDEO:
      return t("Là loại câu hỏi có nhiều lựa chọn video kèm mô tả, và có nhiều đáp án là đúng", "Là loại câu hỏi có nhiều lựa chọn video kèm mô tả, và có nhiều đáp án là đúng");
    case QuestionTypeEnum.CONNECT:
      return t("Là loại câu hỏi có nhiều cặp lựa chọn cần được kết nối với nhau", "Là loại câu hỏi có nhiều cặp lựa chọn cần được kết nối với nhau");
    case QuestionTypeEnum.SHORT_TEXT:
      return t("Là loại câu hỏi cho phép trả lời bằng cách nhập đoạn văn bản ngắn, có nhiều đáp án là đúng", "Là loại câu hỏi cho phép trả lời bằng cách nhập đoạn văn bản ngắn, có nhiều đáp án là đúng");
    case QuestionTypeEnum.FILE_UPLOAD:
      return t("Là loại câu hỏi cho phép trả lời bằng cách gửi lên file đính kèm. hình(video)", "Là loại câu hỏi cho phép trả lời bằng cách gửi lên file đính kèm. hình(video)");
    case QuestionTypeEnum.VIDEO:
      return t("Là loại câu hỏi cho phép trả lời bằng cách gửi lên file ghi hình(video)", "Là loại câu hỏi cho phép trả lời bằng cách gửi lên file ghi hình(video)");
    case QuestionTypeEnum.MP3:
      return t("Là loại câu hỏi cho phép trả lời bằng cách gửi lên file ghi âm", "Là loại câu hỏi cho phép trả lời bằng cách gửi lên file ghi âm");
    case QuestionTypeEnum.CALCULATED:
      return `Là loại câu hỏi cho phép trả lời bằng cách gửi lên kết quả tính toán. Bạn có thể tuỳ biến các giá trị trong câu hỏi và câu trả lời bằng cách đặt một tên biến bất kỳ (ngoại trừ số) đặt trong cặp ngoặc [ ]
      <br/>Ví dụ: [X], [BienA], [delta],...`;
    case QuestionTypeEnum.CALCULATED_SIMPLE:
      return `Là loại câu hỏi cho phép trả lời bằng cách gửi lên kết quả tính toán. Bạn có thể tuỳ biến các giá trị trong câu hỏi và câu trả lời bằng cách đặt một tên biến bất kỳ (ngoại trừ số) đặt trong cặp ngoặc [ ]
      <br/>Ví dụ: [X], [BienA], [delta],...`;
    case QuestionTypeEnum.CALCULATED_MULTI:
      return `Là loại câu hỏi cho phép trả lời bằng cách chọn 1 trong nhiều đáp án dựa trên kết quả tính toán. Bạn có thể tuỳ biến các giá trị trong câu hỏi và câu trả lời bằng cách đặt một tên biến bất kỳ đặt trong cặp ngoặc [ ]
      <br/>Ví dụ: [X], [BienA], [delta],...`;
    case QuestionTypeEnum.ESSAY:
      return t("Là loại câu hỏi cho phép trả lời bằng cách nhập nội dung text, cho phép nhập số lượng ký tự", "Là loại câu hỏi cho phép trả lời bằng cách nhập nội dung text, cho phép nhập số lượng ký tự");
    case QuestionTypeEnum.DRAG_DROP_INTO_TEXT:
      return t("Là loại câu hỏi cho phép trả lời bằng cách kéo thả các từ vào vị trí trống trong đoạn văn bản, mỗi vị trí trống được quy ước bởi 1 cặp ngoặc vuông [[ ]], được đánh số thứ tự bắt đầu từ 1, thứ tự sắp xếp đúng sẽ tương ứng với thứ tự của các từ sắp xếp bên dưới", "Là loại câu hỏi cho phép trả lời bằng cách kéo thả các từ vào vị trí trống trong đoạn văn bản, mỗi vị trí trống được quy ước bởi 1 cặp ngoặc vuông [[ ]], được đánh số thứ tự bắt đầu từ 1, thứ tự sắp xếp đúng sẽ tương ứng với thứ tự của các từ sắp xếp bên dưới");
    default:
      break;
  }
};

export function getPathnameFromUrl(url: string): string {
  try {
    const parsedUrl = new URL(url);

    return parsedUrl.pathname;
  } catch (error) {
    console.error("Invalid URL:", error);
    return "";
  }
}

export const getContrastingColor = (backgroundColor: string) => {
  if (!/^#([0-9A-F]{3}){1,2}$/i.test(backgroundColor)) {
    console.warn(
      `Invalid background color: ${backgroundColor}. Defaulting to black.`
    );
    return "#FFFFFF";
  }
  const color = backgroundColor.slice(1);
  const expandedColor =
    color.length === 3
      ? color
        .split("")
        .map((char) => char + char)
        .join("")
      : color;

  const r = parseInt(expandedColor.substring(0, 2), 16);
  const g = parseInt(expandedColor.substring(2, 4), 16);
  const b = parseInt(expandedColor.substring(4, 6), 16);

  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness < 128 ? "#FFFFFF" : "#000000";
};

export const RenderUnitIcon = (type: string) => {
  switch (type) {
    case "video":
      return <img src={"/images/Cinema.png"} className="multimedia-img" />;
    case "mp3":
    case "audio":
      return <img src={"/images/Audio.png"} className="multimedia-img" />;
    case "text":
      return <img src={"/images/Text.png"} className="multimedia-img" />;
    case "pdf":
      return <img src={"/images/PDF.png"} className="multimedia-img" />;

    case "scorm":
    case "xapi":
      return <img src={"/images/Frames.png"} className="multimedia-img" />;

    default:
      return "";
  }
};
export function downloadWordDocument(
  htmlContent: string,
  fileName: string = "document.docx"
): void {
  const docx = htmlDocx.asBlob(htmlContent);
  saveAs(docx, fileName);
}

const removeDiacritics = (str: string) =>
  str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

export const filterOption = (
  input: string,
  option?: { label: string; value: string }
) =>
  removeDiacritics(option?.label ?? "")
    .toLowerCase()
    .includes(removeDiacritics(input).toLowerCase());

export const formatCurrencyToVND = (amount: number): string => {
  return (
    amount
      ?.toLocaleString("vi-VN", { style: "currency", currency: "VND" })
      .replace("₫", "")
      .trim() + " VNĐ"
  );
};

export const getFirstLetter = (words: string) => {
  return words?.length >= 2
    ? words[0][0].toUpperCase() + words[words.length - 1][0].toUpperCase()
    : "";
};

export const checkAndCountdown = (targetDate: Date): number => {
  const currentDate = new Date();
  const oneDay = 24 * 60 * 60 * 1000;
  const diffInTime = targetDate.getTime() - currentDate.getTime();
  const daysDifference = Math.ceil(diffInTime / oneDay);
  return daysDifference;
};

export const generateRandomId = (prefix: string = ""): string => {
  return uniqueId(prefix);
};

export function parseExpression(tokens: string[]) {
  if (!tokens.length) return;
  const results = [];

  for (let i = 0; i < tokens.length; i++) {
    if (tokens[i]?.startsWith("id{")) {
      let blockId = tokens[i];
      let coefficient = 1.0;

      // Look ahead to find the coefficient for the current id
      for (let j = i + 1; j < tokens.length; j++) {
        if (tokens[j] === "*") {
          coefficient = parseFloat(tokens[j + 1]);
          j++; // Skip the number after '*'
          break;
        }
      }

      results.push({ blockId: blockId, coefficient: coefficient });
    }
  }

  return results;
}

export function parseBlockArray(array: any) {
  if (!array?.length) return [];

  return array.map((item: any) => {
    if (typeof item.blockId === "string" && item.blockId?.startsWith("id{")) {
      return {
        blockId: parseInt(item.blockId.match(/\d+/)[0]),
        coefficient: item.coefficient,
      };
    }
    return item;
  });
}

export function sanitizeExpression(str: string): string {
  // Bước 1: normalize chuỗi, sau đó remove các dấu kết hợp (diacritics)
  //         "đ" và "Đ" cũng được thay thế thành "d" và "D".
  let result = str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // xóa dấu
    .replace(/[đĐ]/g, (m) => (m === "đ" ? "d" : "D"));

  // Bước 2: Thay thế mọi khoảng trắng bằng ký tự ''
  result = result.replace(/\s+/g, "");

  return result;
}

export const convertToLatex = (expression: string): string => {
  if (!expression) return "";
  try {
    const cleaned = sanitizeExpression(expression);
    const node = parse(cleaned);

    let latexString = node.toTex();
    latexString = latexString.replace(/\\cdot/g, "\\times");

    return latexString;
  } catch (error) {
    return "";
  }
};

export function tokenize(expression: string): string[] {
  const regex = /([()+\-*/])|([^()+\-*/]+)/g;
  const tokens: string[] = [];

  let match: RegExpExecArray | null;
  while ((match = regex.exec(expression)) !== null) {
    // match[1] = toán tử, ngoặc
    // match[2] = cụm text (chứa chữ tiếng Việt, chữ thường, số, khoảng trắng...)
    if (match[1]) {
      // Là toán tử hoặc dấu ngoặc => tách riêng
      const operatorOrBracket = match[1].trim();
      if (operatorOrBracket) {
        tokens.push(operatorOrBracket);
      }
    } else if (match[2]) {
      // Là cụm text, trim() để bỏ khoảng trắng đầu/cuối
      const chunk = match[2].trim();
      if (chunk) {
        tokens.push(chunk);
      }
    }
  }

  return tokens;
}
export const mapDataToTreeTable = (data: any[]): any[] => {
  return data.map((item) => {
    return {
      ...item,
      key: item.id,
      children: item.children ? mapDataToTreeTable(item.children) : [],
    };
  });
};

export const renderTestScheduleStatus = (status: number) => {
  switch (status) {
    case 0:
      return t("Chưa diễn ra", "Chưa diễn ra");
    case 1:
      return t("Đang diễn ra", "Đang diễn ra");
    case 2:
      return t("Đã kết thúc", "Đã kết thúc");
    default:
      return t("Chưa đăng ký", "Chưa đăng ký");
  }
};

export const itemRenderPaging: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement
) => {
  if (type === "prev") {
    return <LeftOutlined />;
  }
  if (type === "next") {
    return <RightOutlined />;
  }
  return originalElement;
};

export const RenderRecordedResults = (status: number | null | undefined) => {
  switch (status) {
    case 0:
      return t("Kết quả đầu tiên", "Kết quả đầu tiên");
    case 1:
      return t("Kết quả cuối cùng", "Kết quả cuối cùng");
    case 2:
      return t("Kết quả cao nhất", "Kết quả cao nhất");
    case 3:
      return t("Kết quả trung bình", "Kết quả trung bình");
    default:
      return "-";
  }
};

export const COURSE_STATUS_MAP: Record<
  number,
  { label: string; color: string }
> = {
  [COURSE_STATUS.DRAFT]: { label: "Bản nháp", color: "#D9D9D9" },
  [COURSE_STATUS.PRIVATE]: { label: "Riêng tư", color: "#FAAD14" },
  [COURSE_STATUS.APPROVED_WAIT]: { label: "Chờ duyệt", color: "#1677FF" },
  [COURSE_STATUS.RETURN]: { label: "Bị trả lại", color: "#52C41A" },
  [COURSE_STATUS.APPRISED_WAIT]: { label: "Chờ thẩm định", color: "#1677FF" },
  [COURSE_STATUS.APPRISED_RETURN]: {
    label: "Thẩm định trả lại",
    color: "#FAAD14",
  },
  [COURSE_STATUS.APPRISED]: { label: "Đã thẩm định", color: "#52C41A" },
  [COURSE_STATUS.APPROVED]: { label: "Đã duyệt", color: "#52C41A" },
  [COURSE_STATUS.PROFESSION_APPROVE_WAIT]: {
    label: "Chờ phê duyệt",
    color: "#1677FF",
  },
  [COURSE_STATUS.PROFESSION_APPROVED]: {
    label: "Đã phê duyệt",
    color: "#52C41A",
  },
  [COURSE_STATUS.PROFESSION_APPROVED_RETURN]: {
    label: "Phê duyệt trả lại",
    color: "#FAAD14",
  },
  [COURSE_STATUS.PUBLISHED_WAIT]: { label: "Chờ xuất bản", color: "#1677FF" },
  [COURSE_STATUS.PUBLISHED]: { label: "Đã xuất bản", color: "#52C41A" },
};

export const handleExportExcel = (fileData: any, msg: string) => {
  const blob = new Blob([fileData], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const downloadLink = document.createElement("a");
  downloadLink.href = URL.createObjectURL(blob);

  downloadLink.download = msg;

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  message.success("Tải xuống thành công!");
};